import {
  ANNUAL_REPORT_GET_FOOD_PROGRAM,
  ANNUAL_REPORT_FOOD_PROGRAM
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

export const getFoodProgram =
  (AssociationNumber, BranchNumber) => (dispatch, getState) =>
    asyncRequest({
      url: ANNUAL_REPORT_GET_FOOD_PROGRAM(
        AssociationNumber,
        BranchNumber
      ),
      successAction: data => ({
        type: types.FOOD_PROGRAM_GET_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.FOOD_PROGRAM_GET_FAILURE,
        payload: error
      }),
      dispatch
    });
export const foodProgram = bodyObject => (dispatch, getState) =>
  asyncRequest({
    url: ANNUAL_REPORT_FOOD_PROGRAM(),
    method: 'POST',
    data: bodyObject,
    successAction: data => ({
      type: types.FOOD_PROGRAM_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.FOOD_PROGRAM_FAILURE,
      payload: error
    }),
    dispatch
  });
